import { AxiosResponse } from "axios";
import API from "core/networks/API";
import { IApiResponseSuccess } from "core/networks/Interfaces";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  API_FAVORITES_MAIN,
  API_GET_AI_HISTORY_MAIN,
  API_GET_COMMUNITY_FOLLOWING_MAIN,
  API_GET_COMMUNITY_TRENDING_MAIN,
  API_GET_COMMUNITY_VIDEO_MAIN,
  API_GET_USER_SUGGESTION_MAIN,
  API_MAIN_MY_INGREDIENT,
  API_MAIN_RANDOM_RECIPE,
  API_RELOAD_USER_SUGGESTION_MAIN,
  API_SUGGESTION_BY_TYPE,
  API_WEATHER_MAIN,
} from "../api";
import {
  fetchCommunityFollowMainError,
  fetchCommunityFollowMainSuccess,
  fetchCommunityTrendMainError,
  fetchCommunityTrendMainSuccess,
  fetchCommunityVideoMainError,
  fetchCommunityVideoMainSuccess,
  fetchCoupangRecoSuccess,
  fetchFavoritesMainError,
  fetchFavoritesMainSuccess,
  fetchHistoryMainError,
  fetchHistoryMainSuccess,
  fetchMyIngredientsError,
  fetchMyIngredientsSuccess,
  fetchRandomRecipeError,
  fetchRandomRecipeSuccess,
  fetchSuggestionByTypeError,
  fetchSuggestionByTypeSuccess,
  fetchUserSuggestionError,
  fetchUserSuggestionSuccess,
  fetchWeatherMainError,
  fetchWeatherMainSuccess,
} from "./actions";
import {
  FETCH_COMMUNITY_TREND_MAIN_REQUEST,
  FETCH_COUPANG_RECO_REQUEST,
  FETCH_FAVORITES_MAIN_REQUEST,
  FETCH_HISTORY_MAIN_REQUEST,
  FETCH_MY_INGREDIENTS_REQUEST,
  FETCH_RANDOM_RECIPE_REQUEST,
  FETCH_SUGGESTION_BY_TYPE_REQUEST,
  FETCH_USER_SUGGESTION_MAIN_REQUEST,
  FETCH_WEATHER_MAIN_REQUEST,
  IFetchCommunityTrendMainRequestAction,
  IFetchCommunityMainResponse,
  IFetchFavoritesMainRequestAction,
  IFetchFavoritesMainResponse,
  IFetchHistoryMainRequestAction,
  IFetchHistoryMainResponse,
  IFetchMyIngredientsRequestAction,
  IFetchMyIngredientsResponse,
  IFetchRandomRecipeRequestAction,
  IFetchRandomRecipeResponse,
  IFetchSuggestionByTypeRequestAction,
  IFetchSuggestionByTypeResponse,
  IFetchUserSuggestionMainRequestAction,
  IFetchWeatherMainRequestAction,
  IFetchWeatherMainResponse,
  FETCH_COMMUNITY_FOLLOW_MAIN_REQUEST,
  FETCH_COMMUNITY_VIDEO_MAIN_REQUEST,
  IFetchCommunityFollowMainRequestAction,
  IFetchCommunityVideoMainRequestAction,
  RELOAD_USER_SUGGESTION_MAIN_REQUEST,
} from "./types";
import { API_GET_COUPANG_SEARCH } from "core/api";

function* fetchMyIngredientsRequest(action: IFetchMyIngredientsRequestAction) {
  try {
    const response: AxiosResponse<
      IApiResponseSuccess<IFetchMyIngredientsResponse>
    > = yield call(API.get, API_MAIN_MY_INGREDIENT, action.payload);
    yield put(fetchMyIngredientsSuccess(response.data.data));
  } catch (error) {
    yield put(fetchMyIngredientsError(error as Error));
  }
}

function* fetchRandomRecipeRequest(action: IFetchRandomRecipeRequestAction) {
  try {
    const response: AxiosResponse<
      IApiResponseSuccess<IFetchRandomRecipeResponse>
    > = yield call(API.get, API_MAIN_RANDOM_RECIPE, action.payload);
    yield put(fetchRandomRecipeSuccess(response.data.data));
  } catch (error) {
    yield put(fetchRandomRecipeError(error as Error));
  }
}

function* fetchFavoritesMainRequest(action: IFetchFavoritesMainRequestAction) {
  try {
    const response: AxiosResponse<
      IApiResponseSuccess<IFetchFavoritesMainResponse>
    > = yield call(API.get, API_FAVORITES_MAIN, action.payload);
    yield put(fetchFavoritesMainSuccess(response.data.data));
  } catch (error) {
    yield put(fetchFavoritesMainError(error as Error));
  }
}
//fetchWeatherMainRequestSaga
function* fetchWeatherMainRequestSaga(action: IFetchWeatherMainRequestAction) {
  try {
    const response: AxiosResponse<
      IApiResponseSuccess<IFetchWeatherMainResponse>
    > = yield call(API.get, API_WEATHER_MAIN, action.payload);
    yield put(fetchWeatherMainSuccess(response.data.data));
  } catch (error) {
    yield put(fetchWeatherMainError(error as Error));
  }
}

//fetchHistoryMainRequestSaga
function* fetchHistoryMainRequestSaga(action: IFetchHistoryMainRequestAction) {
  try {
    const response: AxiosResponse<
      IApiResponseSuccess<IFetchHistoryMainResponse>
    > = yield call(API.get, API_GET_AI_HISTORY_MAIN, action.payload);
    yield put(fetchHistoryMainSuccess(response.data.data));
  } catch (error) {
    yield put(fetchHistoryMainError(error as Error));
  }
}

function* fetchSuggestionByTypeRequest(
  action: IFetchSuggestionByTypeRequestAction
) {
  try {
    const response: AxiosResponse<
      IApiResponseSuccess<IFetchSuggestionByTypeResponse>
    > = yield call(API.get, API_SUGGESTION_BY_TYPE, action.payload);
    yield put(
      fetchSuggestionByTypeSuccess(response.data.data, action.payload.type)
    );
  } catch (error) {
    yield put(fetchSuggestionByTypeError(error as Error));
  }
}

function* fetchCoupangRecpoRequest(action: any) {
  try {
    const response: AxiosResponse<any> = yield call(
      API.get,
      API_GET_COUPANG_SEARCH,
      action.payload
    );
    console.log("fetchCoupangRecpoRequest", response.data?.data);
    yield put(fetchCoupangRecoSuccess(response.data));
  } catch (error) {
    console.log("fetchCoupangRecpoRequest", error);
  }
}

function* fetchCommunityTrendMainRequestSaga(
  action: IFetchCommunityTrendMainRequestAction
) {
  try {
    const response: AxiosResponse<
      IApiResponseSuccess<IFetchCommunityMainResponse>
    > = yield call(API.get, API_GET_COMMUNITY_TRENDING_MAIN, action.payload);
    yield put(fetchCommunityTrendMainSuccess(response.data.data));
  } catch (error) {
    yield put(fetchCommunityTrendMainError(error as Error));
  }
}

function* fetchCommunityFollowMainRequestSaga(
  action: IFetchCommunityFollowMainRequestAction
) {
  try {
    const response: AxiosResponse<
      IApiResponseSuccess<IFetchCommunityMainResponse>
    > = yield call(API.get, API_GET_COMMUNITY_FOLLOWING_MAIN, action.payload);
    yield put(fetchCommunityFollowMainSuccess(response.data.data));
  } catch (error) {
    yield put(fetchCommunityFollowMainError(error as Error));
  }
}

function* fetchCommunityVideoMainRequestSaga(
  action: IFetchCommunityVideoMainRequestAction
) {
  try {
    const response: AxiosResponse<
      IApiResponseSuccess<IFetchCommunityMainResponse>
    > = yield call(API.get, API_GET_COMMUNITY_VIDEO_MAIN, action.payload);
    yield put(fetchCommunityVideoMainSuccess(response.data.data));
  } catch (error) {
    yield put(fetchCommunityVideoMainError(error as Error));
  }
} 

//fetchUserSuggetionMainRequestSaga
function* fetchUserSuggetionMainRequestSaga(action: IFetchUserSuggestionMainRequestAction) {
  try {
    const response: AxiosResponse<
      IApiResponseSuccess<IFetchWeatherMainResponse>
    > = yield call(API.get, API_GET_USER_SUGGESTION_MAIN, action.payload);
    yield put(fetchUserSuggestionSuccess(response.data));
  } catch (error) {
    yield put(fetchUserSuggestionError(error as Error));
  }
}

function* reloadUserSuggetionMainRequestSaga(action: IFetchUserSuggestionMainRequestAction) {
  try {
    const response: AxiosResponse<
      IApiResponseSuccess<IFetchWeatherMainResponse>
    > = yield call(API.get, API_RELOAD_USER_SUGGESTION_MAIN, action.payload);
    yield put(fetchUserSuggestionSuccess(response.data));
  } catch (error) {
    yield put(fetchUserSuggestionError(error as Error));
  }
}

export default function* DashboardSaga() {
  yield takeLatest(FETCH_MY_INGREDIENTS_REQUEST, fetchMyIngredientsRequest);
  yield takeLatest(FETCH_RANDOM_RECIPE_REQUEST, fetchRandomRecipeRequest);
  yield takeLatest(FETCH_FAVORITES_MAIN_REQUEST, fetchFavoritesMainRequest);
  yield takeLatest(FETCH_WEATHER_MAIN_REQUEST, fetchWeatherMainRequestSaga);
  yield takeLatest(FETCH_HISTORY_MAIN_REQUEST, fetchHistoryMainRequestSaga);
  yield takeEvery(
    FETCH_SUGGESTION_BY_TYPE_REQUEST,
    fetchSuggestionByTypeRequest
  );
  yield takeLatest(FETCH_COUPANG_RECO_REQUEST, fetchCoupangRecpoRequest);
  yield takeLatest(
    FETCH_COMMUNITY_TREND_MAIN_REQUEST,
    fetchCommunityTrendMainRequestSaga
  );
  yield takeLatest(
    FETCH_COMMUNITY_FOLLOW_MAIN_REQUEST,
    fetchCommunityFollowMainRequestSaga
  );
  yield takeLatest(
    FETCH_COMMUNITY_VIDEO_MAIN_REQUEST,
    fetchCommunityVideoMainRequestSaga
  );
  yield takeLatest(FETCH_USER_SUGGESTION_MAIN_REQUEST, fetchUserSuggetionMainRequestSaga);
  yield takeLatest(RELOAD_USER_SUGGESTION_MAIN_REQUEST, reloadUserSuggetionMainRequestSaga);
}
